import Cookies from "js-cookie";

// Note: validateToken is removed because HTTP-only cookies cannot be read by JavaScript
// Authentication is now verified by making an API call to /auth/info endpoint
// which uses the HTTP-only cookie automatically sent by the browser

export const unauthorizedMiddleware = (store) => (next) => (action) => {
    const status = action.payload?.status;
    if (status === 401) {
        // Clear any non-HTTP-only cookies if they exist
        Cookies.remove('authToken');
        window.location.href = '/login';
        return;
    }

    if (status === 403) {
        // Forbidden → close current tab
        window.close();
        return;
    }

    return next(action);
}
